import { Button, Flex, Select } from "@chakra-ui/react";
import React from "react";
import { FaRegTrashAlt } from "react-icons/fa";

class GradeField extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClickDelete = this.handleClickDelete.bind(this);
  }

  handleInputChange(e) {
    this.props.handleInputChange(e, this.props.id);
  }

  handleClickDelete() {
    this.props.deleteField(this.props.id);
  }

  render() {
    const creditOptions = [];

    for (let i = 1; i < 4; i++) {
      creditOptions.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return (
      <Flex mx="4" my="4">
        <Select
          name="grade"
          onChange={this.handleInputChange}
          placeholder="Дүн"
          my="2"
          mx="2"
        >
          <option value="A">A / 95-100</option>
          <option value="A-">A- / 90-94</option>
          <option value="B">B / 85-89</option>
          <option value="B-">B- / 80-84</option>
          <option value="C">C / 75-79</option>
          <option value="C-">C- / 70-74</option>
          <option value="D">D / 65-69</option>
          <option value="D-">D- / 60-64</option>
          <option value="F">F / 0-59</option>
        </Select>

        <Select
          name="hours"
          onChange={this.handleInputChange}
          placeholder="Кредит"
          my="2"
        >
          {creditOptions}
        </Select>

        <Button
          mx="2"
          my="2"
          px="4"
          size="sx"
          _hover={{
            background: "red.500",
            color: "white",
          }}
          onClick={this.handleClickDelete}
        >
          <FaRegTrashAlt />
        </Button>
      </Flex>
    );
  }
}

export default GradeField;
